module.exports = __webpack_public_path__ + "static/media/blogpost1.69352a3c.png";